import { Column } from '@synqo/frontend-component-library';
import { ApiLedgerAccount } from '@Model';

export const ledgerAccountColumns: Column<ApiLedgerAccount>[] = [
    { name: 'number', label: 'Nummer' },
    { name: 'label', label: 'Bezeichnung' },
];
